export default {"src":"/apac/_next/static/media/Thermo Fisher Scientific.bb0459ba.svg","height":84,"width":384,"blurWidth":0,"blurHeight":0};